import { useFormik } from "formik";
import React, { useEffect } from "react";
import { notification } from "../../../utils/Notifications.tsx";
import {
  createFullDayHours,
  readFullDayHoursByBranch,
} from "../../../services/branchSchedule.service.ts";

const EditFullDayHours = ({ branchId, closeFn, refreshFn, setLoading }) => {
  const formik = useFormik({
    initialValues: {
      branch: branchId,
      fullDayHours: "8.5",
    },
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const fullDayHoursValue = parseFloat(values.fullDayHours);
        if (isNaN(fullDayHoursValue) || (fullDayHoursValue !== 8 && fullDayHoursValue !== 8.5)) {
          notification(
            "Error",
            "Debes seleccionar 8 o 8.5 horas",
            "danger"
          );
          formik.setErrors({ fullDayHours: "Valor inválido" });
          return;
        }

        const data = {
          branch: branchId,
          fullDayHours: fullDayHoursValue,
        };

        const response = await createFullDayHours(data);

        notification(
          "Éxito",
          "Horas de jornada completa actualizadas",
          "success"
        );
        closeFn();
        if (refreshFn) refreshFn();
      } catch (error) {
        notification(
          "Error",
          "Error al actualizar las horas de jornada completa",
          "danger"
        );
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    const existingHours = async () => {
      const response = await readFullDayHoursByBranch(branchId);
      if (response) {
        formik.setValues({
          branch: branchId,
          fullDayHours: String(response.fullDayHours || 8.5),
        });
      }
    };
    existingHours();
  }, [branchId]);

  return (
    <React.Fragment>
      <div>
        <h5 className="pb-2">Configurar horas de jornada completa</h5>
        <p className="text-muted mb-3">
          Define cuántas horas se consideran una jornada completa para esta
          sucursal. Este valor se utilizará en todos los cálculos de nómina y
          asistencia.
        </p>
        <div className="mb-3">
          <label htmlFor="fullDayHours" className="form-label">
            Horas de jornada completa
          </label>
          <select
            id="fullDayHours"
            className={`form-control ${
              formik.errors.fullDayHours ? "is-invalid" : ""
            }`}
            value={formik.values.fullDayHours}
            onChange={(e) =>
              formik.setFieldValue("fullDayHours", e.target.value)
            }
            onBlur={formik.handleBlur}
          >
            <option value="8">8 horas</option>
            <option value="8.5">8.5 horas</option>
          </select>
          {formik.errors.fullDayHours && (
            <div className="invalid-feedback">{formik.errors.fullDayHours}</div>
          )}
          <small className="form-text text-muted">
            Selecciona las horas de jornada completa para esta sucursal
          </small>
        </div>
      </div>
      <div className="d-flex justify-content-end mt-4">
        <button className="btn btn-secondary me-2" onClick={() => closeFn()}>
          Cancelar
        </button>
        <button className="btn btn-azul" onClick={() => formik.handleSubmit()}>
          Actualizar
        </button>
      </div>
    </React.Fragment>
  );
};

export default EditFullDayHours;
